import _ from "underscore";
import "bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js";

const DatePickerDirective = function () {
    return {
        restrict: 'A',
        scope: {
            format: '@?',
            minDate: '=?',
            maxDate: '=?'
        },
        link: function (scope, element, attrs) {
            function isDefined(arg) {
                return !_.isUndefined(arg);
            }
            // If value for date-picker attribute is not specified, default to 'date'.
            var kind = isDefined(attrs.datePicker) && !_.isEmpty(attrs.datePicker) ? attrs.datePicker : "date";

            var params: any = {
                time: kind.indexOf('time') >= 0,
                date: kind.indexOf('date') >= 0,
            };

            // note: `params.format` controls the format of both
            //	- the output produced by picking a value
            //	- the expected input format
            // Initialisation of `params.minDate` and `params.maxDate` is deliberately 
            // omitted, as it would be redundant, being immediately followed by configuration
            // changes applied by the `minDate` and `maxDate` `scope.$watch` callbacks.
            if (isDefined(scope.format)) params.format = scope.format;

            element.bootstrapMaterialDatePicker(params);

            scope.$watch("minDate", function (value) {
                if (!value) {
                    value = null;
                } else {
                    // Assume that value is a string in a format that matches `params.format`.
                    // note: if `value` doesn't match `params.format`, then `bootstrapMaterialDatePicker` will misinterpret the value.
                }
                element.bootstrapMaterialDatePicker('setMinDate', value);
            });

            scope.$watch("maxDate", function (value) {
                if (!value) {
                    value = null;
                } else {
                    // Assume that value is a string in a format that matches `params.format`.
                    // note: if `value` doesn't match `params.format`, then `bootstrapMaterialDatePicker` will misinterpret the value.
                }
                element.bootstrapMaterialDatePicker('setMaxDate', value);
            });

            // destroy bootstrapMaterialDatePicker object,
            // when the target elemet is removed from the DOM.
            scope.$on("destroy", function () {
                element.bootstrapMaterialDatePicker('destroy');
            });
        }
    }
};

export { DatePickerDirective };